<template>
  <div class="container-fluid background-gray">
    <Header
      @expantSideBarOnHover="expantSideBarOnHover"
      @hideSideBar="hideSideBar"
    />
    <v-row class="background-gray">
      <div
        class="pb-0 vh-height sidebar-wrapper"
        v-if="showSideBar && !display"
      >
        <SideBar
          :mini="miniClass"
          @closeSideBar="closeSideBar"
          :windowWidth="display"
          :showSideBar="showSideBar"
        ></SideBar>
      </div>
      <div
         :class="
          showSideBar
            ? 'pb-0  vh-height sidebar-wrapper'
            : 'pb-0 vh-height sidebar-wrapper-mini'
        "
        v-else-if="display"
      >
        <SideBar
          :mini="miniClass"
          @closeSideBar="closeSideBar"
          :windowWidth="display"
          :showSideBar="showSideBar"
        ></SideBar>
      </div>
      <div
        v-if="mobileSideBar"
       :class="!showSideBar ? 'main-wrapper' : 'main-wrapper-mini'"
      >
        <div class="context no-padding-left">
          <div class="row no-padding">
            <RoutePath :path="path"></RoutePath>
          </div>
          <BlueNavbar :tab="tab"></BlueNavbar>
          <div
            :class="hideWhiteBack ? 'home-tables' : 'white-background tables'"
          >
            <Home
              v-if="route == '/provider' || route == '/provider/home'"
            ></Home>
            <Employers></Employers>
            <Members></Members>
            <PriorAuth></PriorAuth>
            <Providers></Providers>
            <Advisors></Advisors>
            <Networks></Networks>
            <Bundles></Bundles>
            <Contract></Contract>
            <Settings></Settings>
             <Profile v-if="$route.path.includes('profile')" />
          </div>
        </div>
      </div>
    </v-row>
  </div>
</template>
<script>
import Header from "../components/Sections/Provider//Header.vue";
import SideBar from "../components/Sections/Provider/Layout/ProviderSideBar.vue";
import RoutePath from "../components/TablesTemplate/RoutePath.vue";
import BlueNavbar from "../components/Sections/Provider/Layout/BlueNavbar.vue";
import Home from "../components/Sections/Provider/Home/Home.vue";
import Employers from "../components/Sections/Provider/Employers/EmployerTemplate.vue";
import Members from "../components/Sections/Provider/Members/MembersTemplate.vue";
import PriorAuth from "../components/Sections/Provider/PriorAuths/PriorTemplate.vue";
import Providers from "../components/Sections/Provider/Providers/ProvidersTemplate.vue";
import Advisors from "../components/Sections/Provider/Advisors/AdvisorTemplate.vue";
import Networks from "../components/Sections/Provider/Networks/NetworksTemplate.vue";
import Bundles from "../components/Sections/Provider/Bundles/BundlesTemplate.vue";
import Contract from "../components/Sections/Provider/Contract/ContractTemplate.vue";
import Settings from "../components/Sections/Provider/Settings/SettingsTemplate.vue";
import Profile from '../components/TablesTemplate/MyProfile.vue'

export default {
  components: {
    Header,
    SideBar,
    RoutePath,
    BlueNavbar,
    Home,
    Employers,
    Members,
    PriorAuth,
    Providers,
    Contract,
    Networks,
    Bundles,
    Settings,
    Advisors,
    Profile
    
  },
  data() {
    return {
      sideBar: true,
      showSideBar: false,
      display: true,
      windowWidth: window.innerWidth,
      page: "",
      clientName: "",
      miniClass: false,
      clientItem: null,
      path: "",
      tab: "",
    };
  },
  created() {
    if (this.windowWidth < 959) {
      this.display = false;
    } else {
      this.display = true;
    }

    if (this.route.includes("provider/employers/employer")) {
      this.$router.replace("/provider/employers");
    } else if (
      this.route.includes("provider/advisors/advisor") ||
      this.route.includes("/advisors/add-new/result")
    ) {
      this.$router.replace("/provider/advisors");
    } else if (
      this.route.includes("provider/advisors/advisor") ||
      this.route.includes("/advisors/add-new/result")
    ) {
      this.$router.replace("/provider/advisors");
    } else if (this.route.includes("/provider/contracts/contract")) {
      this.$router.replace("/provider/contracts");
    } else if (
      this.route.includes("provider/partners/result") ||
      this.route.includes("/provider/providers/provider") ||
      this.route.includes("/provider/providers/result/npi") ||
      this.route.includes("/provider/affiliates/provider") ||
      this.route.includes("/provider/affiliates/result/npi") ||
      this.route.includes("/provider/affiliates/result") ||
      this.route.includes("provider/hospital-based/result") ||
      this.route.includes("/provider/hospital-based/provider") ||
      this.route.includes("/provider/hospital-based/result/npi")
    ) {
      this.$router.replace("/provider/providers");
    } else if (this.route.includes("provider/users/user")) {
      this.$router.replace("/provider/users");
    }
  },
  computed: {
    hideWhiteBack() {
      let hide = false;
      if (this.route == "/provider" || this.route == "/provider/home") {
        hide = true;
      }
      return hide;
    },
    mobileSideBar() {
      let show;
      if (this.display) {
        show = true;
      } else if (!this.showSideBar && !this.display) {
        show = true;
      }
      return show;
    },
    route() {
      return this.$route.path;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    getProvidersByClient(item) {
      if (item) {
        this.clientItem = item;
        this.clientName = item.name;
      }
    },
    closeSideBar() {
      if (!this.display) {
        this.showSideBar = false;
      } else {
        this.showSideBar = true;
      }
    },
    getClientName(name) {
      this.clientName = name;
    },

    onResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 959) {
        this.display = false;
      } else {
        this.display = true;
      }
    },
    hideSideBar() {
      this.showSideBar = !this.showSideBar;
    },
    expantSideBarOnHover(mini) {
      this.showSideBar = !this.showSideBar;
      this.miniClass = !this.miniClass;
    },
  },
};
</script>

